import type { ExtractorData } from 'Core/actions/dialog';
import type { ReduxStateType } from 'Core/store';

export const extractorDataSelector = (state: ReduxStateType): ExtractorData => state.dialog.extractorData;

export function createDialogOpenedSelector(name: string) {
  return (state: ReduxStateType): boolean => state.dialog.opened.includes(name);
}
